import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './CompareModeNavButton.module.scss';

interface CompareModeNavButtonProps {
  type: 'left' | 'right';
  isDisabled?: boolean;
  toggleCurrentColumn?: () => void;
}

export const CompareModeNavButton = ({
  type,
  isDisabled,
  toggleCurrentColumn,
}: CompareModeNavButtonProps) => {
  return (
    <Button
      color="transparent"
      shape="round"
      onClick={toggleCurrentColumn}
      disabled={isDisabled}
      className={styles.root}
    >
      {type === 'left' ? (
        <CaretLeft size={SVG_SIZE_M} />
      ) : (
        <CaretRight size={SVG_SIZE_M} />
      )}
    </Button>
  );
};
